import { z } from "zod";
import { NOTIFICATION_TYPE_VALUES } from "../enum.js";

export const testNotificationSchema = z.object({
	type: z.enum(NOTIFICATION_TYPE_VALUES),
});

export type TestNotificationPayload = z.infer<typeof testNotificationSchema>;
